import React, { useEffect, useState } from "react";
import { Snackbar, Alert, Zoom } from "@mui/material";
import { useNetworkStatus } from "hooks/useNetworkStatus";

const NetworkStatusNotification: React.FC = () => {
  const { isOnline, justCameOnline } = useNetworkStatus();
  const [showOfflineAlert, setShowOfflineAlert] = useState(false);
  const [showOnlineAlert, setShowOnlineAlert] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setShowOfflineAlert(true);
      setShowOnlineAlert(false);
    } else if (justCameOnline) {
      setShowOfflineAlert(false);
      setShowOnlineAlert(true);
      // Auto-hide the "back online" message after 3 seconds
      const timer = setTimeout(() => {
        setShowOnlineAlert(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isOnline, justCameOnline, showOfflineAlert, showOnlineAlert]);

  const handleOfflineClose = (): void => {
    // Don't allow closing offline alert - keep it visible until back online
    return;
  };

  const handleOnlineClose = (): void => {
    setShowOnlineAlert(false);
  };

  return (
    <>
      {/* Offline Alert */}
      <Snackbar
        open={showOfflineAlert}
        onClose={handleOfflineClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{ zIndex: 9999 }}>
        <Zoom in={showOfflineAlert}>
          <Alert
            severity="error"
            variant="filled"
            onClose={handleOfflineClose}
            sx={{
              width: "fit-content",
              "& .MuiAlert-action": {
                display: "none", // Hide close button for offline alert
              },
              justifyContent: "center",
            }}>
            You're offline.
          </Alert>
        </Zoom>
      </Snackbar>

      {/* Back Online Alert */}
      <Snackbar
        open={showOnlineAlert}
        autoHideDuration={3000}
        onClose={handleOnlineClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{ zIndex: 9999 }}>
        <Zoom in={showOnlineAlert}>
          <Alert
            severity="success"
            variant="filled"
            onClose={handleOnlineClose}
            sx={{
              width: "fit-content",
              justifyContent: "center",
            }}>
            You're back online!
          </Alert>
        </Zoom>
      </Snackbar>
    </>
  );
};

export default NetworkStatusNotification;
